import React, { useEffect, useContext, useState } from 'react';
import UI_Header from '../components/UI_Header';
import UI_Ribbon_MapEditor from '../components/MapEditor/UI_Ribbon_MapEditor';
import UI_NavigationRail_MapEditor from '../components/MapEditor/UI_NavigationRail_MapEditor';
import UI_Panels_Controls from '../components/ERUMAUI/UI_Panels_Controls';
import UI_Panels_MapEditor from '../components/MapEditor/UI_Panels_MapEditor';
import UI_NavigationRail from '../components/ERUMAUI/UI_NavigationRail';
import UI_Slide_Manager from '../components/ERUMAUI/UI_Slide_Manager';
import UI_Subwindow_Manager from '../components/ERUMAUI/UI_Subwindow_Manager';
import { useNavigate, useLocation } from 'react-router-dom';
import UI_Subwindows from '../components/UI_Subwindows';
import { Context_UI } from '../Contexts/Context_UI';
import Context_Provider_MapEditor from '../Contexts/Context_MapEditor';
import Context_Provider_Templating from '../Contexts/Context_Templating';
import Context_Provider_MapRenderer from '../Contexts/Context_MapRenderer';
import Panel_Map_Left from '../components/InteractiveMap/Panel_Map_Left';
import Panel_MapEditor_Right from '../components/MapEditor/Panel_MapEditor_Right';
import Panel_MapEditor_Center from '../components/MapEditor/Panel_MapEditor_Center';
import Panel_MapEditor_Bin_Center from '../components/MapEditor/Panel_MapEditor_Bin_Center';
import Panel_MapEditor_Table_Center from '../components/MapEditor/Panel_MapEditor_Table_Center';

import Icon_Arrow_Left from '../Assets/Icons/Icon_Arrow_Left.png';
import Icon_Add from '../Assets/Icons/Icon_Add.png';
import Icon_Edit from '../Assets/Icons/Icon_Edit.png';
import Icon_Table from '../Assets/Icons/Icon_Table.png';
import Icon_Delete from '../Assets/Icons/Icon_Delete.png';

import Subwindow_Modal_UnsavedChanges from '../components/Subwindow_Modal_UnsavedChanges';
import Subwindow_MapEditor_Add from '../components/MapEditor/Subwindow_MapEditor_Add';
import Subwindow_MapEditor_RippleDelete from '../components/MapEditor/Subwindow_MapEditor_RippleDelete';
import Subwindow_MapEditor_Restore from '../components/MapEditor/Subwindow_MapEditor_Restore';

import { useAuth } from '../Contexts/AuthContext';

export default function DR_MapEditor() {
    const UI = useContext(Context_UI);
    const { Account } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        UI.Page_Navigator_Set(navigate);
        // UI.Initialize();
        UI.LoadingScreen_Hide("Screen_Loading");
    }, []);

    // Match Slide_ID with a slide property on App_Properties.
    const [Composition_Slide, Composition_Slide_Set] = useState([]);
    // Applies to the entire page
    const [Composition_Navigation, Composition_Navigation_Set] = useState([]);
    useEffect(() => {
        Composition_Slide_Set([
            {
                Slide_ID: "MapEditor",
                Panel_Left: <Panel_Map_Left />,
                Panel_Center: <Panel_MapEditor_Center />,
                Panel_Right: <Panel_MapEditor_Right />,
                Active: () => true,
                Ribbon: {
                    Active: () => true,
                    Contents: [
                        {
                            Icon: Icon_Add,
                            Text: "Add building",
                            Destination: "/map/edit/add/building",
                            Action: null,
                            Active: () => true
                        },
                        {
                            Icon: Icon_Add,
                            Text: "Add floor",
                            Destination: "/map/edit/add/floor",
                            Action: null,
                            Active: () => true
                        },
                        {
                            Icon: Icon_Add,
                            Text: "Add room",
                            Destination: "/map/edit/add/room",
                            Action: null,
                            Active: () => true
                        }
                    ]
                }
            },
            {
                Slide_ID: "MapEditor_Table",
                Panel_Left: null,
                Panel_Center: <Panel_MapEditor_Table_Center />,
                Panel_Right: <Panel_MapEditor_Right />,
                Active: () => true,
                Ribbon: {
                    Active: () => false,
                    Contents: []
                }
            },
            {
                Slide_ID: "MapEditor_Bin",
                Panel_Left: null,
                Panel_Center: <Panel_MapEditor_Bin_Center />,
                Panel_Right: <Panel_MapEditor_Right />,
                Active: () => true,
                Ribbon: {
                    Active: () => false,
                    Contents: []
                }
            }
        ]);
        Composition_Navigation_Set([
            {
                Routes: ["/"],
                Destination: "/map",
                Icon: Icon_Arrow_Left,
                Text: "Exit editor",
                hasBadge: false,
                LoadingScreen: false,
                Active: () => true
            },
            {
                Routes: ["/map/edit"],
                Destination: "/map/edit",
                Icon: Icon_Edit,
                Text: "Map view",
                hasBadge: false,
                LoadingScreen: false,
                Active: () => true
            },
            {
                Routes: ["/map/edit/table"],
                Destination: "/map/edit/table",
                Icon: Icon_Table,
                Text: "Table view",
                hasBadge: false,
                LoadingScreen: false,
                Active: () => true
            },
            {
                Routes: ["/map/edit/bin"],
                Destination: "/map/edit/bin",
                Icon: Icon_Delete,
                Text: "Bin",
                hasBadge: false,
                LoadingScreen: false,
                Active: () => true
            }
        ])
    }, [Account, location.pathname]);



    // Define all the subwindows the page's slides use
    const [Composition_Subwindow, Composition_Subwindow_Set] = useState([
        {
            ID: "Window_General_UnsavedChanges",
            Component: <Subwindow_Modal_UnsavedChanges />
        },
        {
            ID: "Window_MapEditor_Add",
            Component: <Subwindow_MapEditor_Add />
        },
        {
            ID: "Window_MapEditor_RippleDelete",
            Component: <Subwindow_MapEditor_RippleDelete />
        },
        {
            ID: "Window_MapEditor_Restore",
            Component: <Subwindow_MapEditor_Restore />
        }
    ]);


    return (
        <Context_Provider_MapEditor>
            <ui-main>
                <UI_Subwindow_Manager Composition={Composition_Subwindow} />
                <UI_Header />
                <UI_NavigationRail Composition={Composition_Navigation} />
                <UI_Slide_Manager Composition={Composition_Slide} />
            </ui-main>
        </Context_Provider_MapEditor>
    )
}